
<div :class="$style.root">
    <j-jflow
        ref="jflow"
        :class="$style.wrapper"
        :genVueComponentKey="genVueComponentKey"
        :configs="configs"
        :loading="jflowloading"
        @instancemousemove="onmousemove"
        @zoompan="onZoomPan"
        @update:loading="onUpdate">
        <template #ProcessNode="{ source }">
            <process-node :node="source"></process-node>
        </template>
        <template #plainlink="{ configs }">
            <process-link :node="configs.source" :configs="configs" @drop="onDropToLink($event, configs)"></process-link>
        </template>
    </j-jflow>
    <poppup-comp :meta="poppups.poppupMeta"></poppup-comp>
    <div :class="$style.operator">
        <div :class="[$style.operatorIcon]" @click="zoomInHandler">
            <img :src="zoomInIcon"/>
        </div>
        <div :class="[$style.operatorIcon]" @click="zoomOutHandler">
            <img :src="zoomOutIcon"/>
        </div>
        <div :class="[$style.operatorIcon]" @click="onFit">
            <img :src="fitIcon"/>
        </div>
    </div>
</div>
